import { useRouter } from "next/router";
import { Trans, useTranslation } from "next-i18next";
import { useRecoilValue } from "recoil";

import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";
import useOnceActivatedIntersectionObserver from "@sellernote/features/src/common/hooks/useOnceActivatedIntersectionObserver";
import { FORWARDING_AUTH_ATOMS } from "@sellernote/features/src/forwarding/recoil-states/auth";
import Button from "@sellernote/ui/src/sds-v2/components/button/Button";
import FourChevronRightIcon from "@sellernote/ui/src/sds-v2/components/svgIcons/FourChevronRightIcon";

import Styled from "./index.styles";

export default function MoveRegisterSection() {
  const { t } = useTranslation(["page-sourcing"]);

  const { isMobile } = useCheckIsMobile();

  const { target, isActivatedTarget } = useOnceActivatedIntersectionObserver({
    threshold: 0.3,
  });

  const isLoggedIn = useRecoilValue(FORWARDING_AUTH_ATOMS.USER_LOGGED_IN);

  const { push } = useRouter();

  return (
    <Styled.container
      ref={target}
      backgroundImageUrl={
        isMobile
          ? "/assets/images/sourcing/register-section-bg-m.webp"
          : "/assets/images/sourcing/register-section-bg.webp"
      }
    >
      <Styled.content>
        <Styled.title
          className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
        >
          {isLoggedIn ? (
            <Trans
              i18nKey="page-sourcing:운송비_할인쿠폰_발급_및_적용방법을_소개해요_br/_아래_절차에_따라_진행_시___em_물류비_쿠폰이_발급_/em_됩니다_"
              components={{
                br: <br />,
                em: <em />,
              }}
            />
          ) : (
            <Trans
              i18nKey="page-sourcing:운송비_할인쿠폰_발급_및_적용방법을_소개해요_br/_우선__em_디지털_포워딩_쉽다를_가입_/em_하세요_"
              components={{
                br: <br />,
                em: <em />,
              }}
            />
          )}
        </Styled.title>

        {!isLoggedIn && (
          <Button
            className={`register-button fade-up-animation ${
              isActivatedTarget ? "active" : ""
            }`}
            theme="tertiary"
            borderType="outlined"
            size="normal"
            label={t("page-sourcing:회원가입_하기")}
            handleClick={() => push("/register")}
            iconInfo={{
              Icon: FourChevronRightIcon,
              position: "right",
            }}
          />
        )}
      </Styled.content>
    </Styled.container>
  );
}
